import { OrderResponse } from "@deliverr/freight-client";

export const getOrderBolId = (order: OrderResponse) => order.orderItems[0].customerBolId!;
